module.exports = __webpack_public_path__ + "img/3.5960cb66.png";